import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateFieldShapeAdmin } from "services";

import { GET_FIELDS_SHAPE_ADMIN, GET_FIELD_SIZE_UPDATES, GET_FIELD_VERIFICATION_SHAPE, UPDATE_FIELD_SHAPE_AMDIN } from "consts";

export const useUpdateFieldShapeAdmin = ({ farmId, fieldId, fieldVerificationId }: { farmId: string; fieldId: string; fieldVerificationId: string }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [UPDATE_FIELD_SHAPE_AMDIN, fieldId],
    mutationFn: updateFieldShapeAdmin,
    onSuccess: () => {
      const queryKeys = [
        [GET_FIELDS_SHAPE_ADMIN, farmId],
        [GET_FIELD_VERIFICATION_SHAPE, fieldVerificationId],
        [GET_FIELD_SIZE_UPDATES, fieldId],
      ];

      Promise.all(queryKeys.map((queryKey) => queryClient.invalidateQueries({ queryKey })));
    },
  });
};
